import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN' // element-ui lang
import elementEsLocale from 'element-ui/lib/locale/lang/es' // element-ui lang
import elementJaLocale from 'element-ui/lib/locale/lang/ja' // element-ui lang
import enLocale from './en.js'
import zhLocale from './zh.js'
import esLocale from './es.js'
import jaLocale from './ja.js'
import { STORAGE_PREFIX } from '@/config/storage'

Vue.use(VueI18n)

const moduleComponent = require.context('./modules', true, /\.js$/)
const moduleIn18 = {
  en: {},
  zh: {}
}
moduleComponent.keys().forEach(item => {
  const key = item.split('/')[2].substring(0, 2)
  if (key === 'zh') {
    moduleIn18.zh = Object.assign(
      moduleIn18[key],
      moduleComponent(item).default
    )
  } else {
    moduleIn18.en = Object.assign(
      moduleIn18[key],
      moduleComponent(item).default
    )
  }
})
const messages = {
  en_US: {
    ...moduleIn18.en,
    ...enLocale,
    ...elementEnLocale
  },
  zh_CN: {
    ...moduleIn18.zh,
    ...zhLocale,
    ...elementZhLocale
  },
  es: {
    ...esLocale,
    ...elementEsLocale
  },
  ja: {
    ...jaLocale,
    ...elementJaLocale
  }
}

export function getLanguage () {
  const chooseLanguage =
    Cookies.get('language') || localStorage.getItem(STORAGE_PREFIX + 'lang')
  if (chooseLanguage) return chooseLanguage

  // if has not choose language
  // Browser returns e.g. 'zh-CN' (hyphen); our locale keys use 'zh_CN' (underscore).
  // Normalize both sides so OS language detection works for Chinese users.
  const language = (
    navigator.language || navigator.browserLanguage
  ).toLowerCase().replace(/-/g, '_')
  const locales = Object.keys(messages)
  for (const locale of locales) {
    if (language.indexOf(locale.toLowerCase()) > -1) {
      return locale
    }
  }
  // Fallback by language prefix
  if (language.indexOf('zh') === 0) return 'zh_CN'
  if (language.indexOf('en') === 0) return 'en_US'
  return 'en_US'
}

/**
 * 获取导出的语言 需要提交至后端
 */
export function getExportLanguage () {
  return getLanguage()
}

const i18n = new VueI18n({
  locale: getLanguage(),
  messages,
  silentTranslationWarn: true
})

export default i18n
